// PR 5 file inputs: typed attachment failure codes surface on the chat error
// message (`message.error.code`). The codes originate from the backend
// ValidationError details and are localized here instead of showing the raw
// server envelope text.
import type { I18n } from '@govard/i18n-core';

type Translator = I18n['t'];

const FILE_INPUT_ERROR_KEYS: Record<string, string> = {
  quota_exceeded: 'crm.ai_chat.quota.exceeded',
  storage_quota_exceeded: 'crm.ai_chat.quota.storage_exceeded',
  legacy_office: 'crm.ai_chat.file_input.error.legacy_office',
  image_not_supported: 'crm.ai_chat.file_input.error.image_not_supported',
  empty_content: 'crm.ai_chat.file_input.error.empty_content',
  unsupported_content_type: 'crm.ai_chat.file_input.error.unsupported_content_type',
};

/**
 * Localized copy for a typed file-input failure code, or null when the code is
 * not one of the known file codes (the caller then keeps the original error
 * message).
 */
export function localizedFileInputError(code: string | undefined, t: Translator): string | null {
  if (code === undefined) return null;
  const key = FILE_INPUT_ERROR_KEYS[code];
  return key === undefined ? null : t(key);
}
